import { CaseEntry } from '../../../graphql/graphql';
import { PreviewFile } from '../../../Components/MediaViewer/MediaViewer';

export const prepareCaseEntryFileForMediaViewer = (
	caseEntry: CaseEntry,
	socketUrl: string,
): PreviewFile => {
	const imageExtensions = ['jpg', 'jpeg', 'png', 'gif'];
	const file = caseEntry.file;
	const fileType =
		imageExtensions.indexOf(file?.extension ?? '') !== -1
			? 'image'
			: file?.extension === 'pdf'
			? 'pdf'
			: 'none';
	const url = `${socketUrl}/cases/${caseEntry.caseId}/message/${caseEntry.fileId}`;
	return {
		id: caseEntry.fileId,
		name: caseEntry.message,
		displayName: caseEntry.message,
		type: fileType,
		preview: `${url}?download=1`,
		download: `${url}?download=2`,
	} as PreviewFile;
};

export const getCaseEntryFileThumbUrl = (
	caseEntry: CaseEntry,
	socketUrl: string,
): string => {
	return `${socketUrl}/cases/${caseEntry.caseId}/message/${caseEntry.fileId}/preview`;
};
